import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import ConfigContext from '../../../contexts/ConfigContext';
import { useGetBlogCategoryByIdQuery } from '../../../redux/slices/blogCategorySlice';
import { useGetBlogPostsQuery } from '../../../redux/slices/blogPostSlice';
import usePagination from '../../../hooks/usePagination';

// Components
import Hero from '../content/Hero';
import QuoteCta from '../content/QuoteCta';
import Meta from '../../shared/Meta';
import BlogPostTease from './BlogPostTease';
import BlogSidebar from './BlogSidebar';
import CateringCta from '../content/CateringCta';
import Paginate from '../../shared/Paginate';

// Styles
import paginateRoundTheme from '../../shared/Paginate-round.module.postcss';
import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './BlogCategory.module.postcss';

function BlogCategory() {
  const { base_url, city_name, vehicle_type } = useContext(ConfigContext);
  const { id } = useParams();
  const location = useLocation();

  const [page, setPage] = useState(1);

  const { data: blogCategory = {} } = useGetBlogCategoryByIdQuery(id);
  const { data = {} } = useGetBlogPostsQuery({
    published: true,
    blog_category: id,
    page_size: 6,
    page,
  });
  const blogPosts = data.blog_posts || [];
  const pagination = data.pagination;

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const newPage = urlParams.get('page') || 1;
    setPage(newPage);
  }, [location.search]);

  const { paginationProps, showPagination } = usePagination({
    pagination,
    options: { theme: paginateRoundTheme, previousLabel: '<', nextLabel: '>' }
  });

  const structuredData = {
    breadcrumbs: { listItems: [
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Blog',
          item: base_url + '/blog',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: blogCategory.name,
          item: base_url + location.pathname,
        },
      ] },
  };

  return (
    <div>
      <Meta
        title={blogCategory.name}
        type="website"
        description={`Food blog covering ${city_name}'s best food ${vehicle_type.toLowerCase()}s, new food trends, and upcoming chefs in the food ${vehicle_type.toLowerCase()} world!`}
        structuredData={structuredData}
      />

      <Hero photo='https://static.seattlefoodtruck.com/photos/home-hero.webp' />

      <div className='Section Section--extraPadding u-pb0'>
        <h1 className='u-mb0'>News & Stories</h1>
      </div>

      <div className='Section Section--extraPadding'>
        <div className={sidebarStyles.SidebarLayout}>
          <div className={sidebarStyles.SidebarLayout_body}>

            <div className='InnerSection u-pt0'>
              <h2 className='u-mb1'>{blogCategory.name}</h2>
              <hr className='u-mb2' />
              <QuoteCta />
            </div>

            <div className='InnerSection'>
              <div className={styles.BlogGrid}>
                { blogPosts.map((blogPost) => {
                  return (
                    <BlogPostTease blogPost={blogPost} key={blogPost.id} />
                  );
                })}
              </div>
              { showPagination && <Paginate {...paginationProps} /> }
            </div>

            {/* TODO instagram */}

            <div className='InnerSection u-pb0'>
              <CateringCta />
            </div>

          </div>
          <div className={sidebarStyles.SidebarLayout_sidebar}>
            <BlogSidebar />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogCategory;
